import '../../../css/bem/_associated_product.scss';

export const wishlistGetProductId = (ele) => {
    if (ele.dataset.pid) return ele.dataset.pid;
    return ele.closest('[data-pid]').getAttribute('data-pid');
};

export const associatedSwatchRollovers = (context = document) => {
    context.querySelectorAll('.associated-product')?.forEach((product: HTMLElement) => {
        product.addEventListener('mouseenter', () => {
            setTimeout(() => {
                swatchHoverSetup(product);
            }, 200);
        });
    });
};

export const swatchHoverSetup = (product) => {
    let debounce;
    // On swatch hover replace main image with swatch image    
    const productSwatches = product.querySelectorAll('.product-colour-swatch') as NodeListOf<HTMLElement>;
    if (productSwatches.length > 0) {
        productSwatches.forEach((swatch: HTMLLinkElement) => {
            swatch.addEventListener('mouseenter', (evt) => {
                const mainImage = product.querySelector('.js-product-image') as HTMLImageElement;
                const target = swatch.dataset.img;
                if (mainImage && target) {
                    mainImage.setAttribute('src', target);
                    window.clearTimeout(debounce);
                }                
            });
            swatch.addEventListener('mouseleave', (evt) => {
                debounce = window.setTimeout(() => {
                    const mainImage = product.querySelector('.js-product-image') as HTMLImageElement;
                    mainImage?.setAttribute('src', mainImage.dataset.src);
                }, 250);
            });
        });
    }
}
